var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../../less/IdStyles";
import { selectActiveTutorialConfig } from "../../../../selectors/selectTutorial";
import { IdLoca } from "../../../../utils/i18n/IdLoca";
import { DialogWrapper } from "../../../dialog/DialogWrapper";
import { ButtonDialog } from "../../../errors/ButtonDialog";
import { BigCharacter } from "../../../generic/big-character/BigCharacter";
import { IdBigCharacter } from "../../../generic/big-character/IdBigCharacter";
import { TextLoca } from "../../../generic/text/TextLoca";
import { actionTutorialComplete } from "../../actionTutorial";
var TutorialCompleteDOM = /** @class */ (function (_super) {
    __extends(TutorialCompleteDOM, _super);
    function TutorialCompleteDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TutorialCompleteDOM.prototype.render = function () {
        var _a = this.props, tutorialConfig = _a.tutorialConfig, onClick = _a.onClick;
        if (tutorialConfig === undefined) {
            // tslint:disable-next-line:no-null-keyword
            return null;
        }
        return (React.createElement(DialogWrapper, { className: IdStyles.ModalBackground, titleLocaId: IdLoca.quest_tutorial_welcome_title },
            React.createElement(BigCharacter, { idStyle: IdStyles.TutorialCharacterPlaceholder, className: "big-character-tutorial-complete big-character-flip", name: IdBigCharacter.TessaLeftSide }),
            React.createElement("div", { className: "flex flex--guts w100 h100" },
                React.createElement("div", { className: "flex flex--auto flex--stacked flex--around h100" },
                    React.createElement("div", { className: "tutorial-balloon " + IdStyles.TutorialBalloon },
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(TextLoca, { id: tutorialConfig.idLocaDescription }))),
                    React.createElement(ButtonDialog, { onClick: onClick })))));
    };
    return TutorialCompleteDOM;
}(React.Component));
var mapState = function (state) {
    var tutorialConfig = selectActiveTutorialConfig(state);
    return {
        tutorialConfig: tutorialConfig,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClick: function () { return dispatch(actionTutorialComplete()); },
}); };
export var TutorialComplete = connect(mapState, mapDispatch)(TutorialCompleteDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/components/tutorial-finish/TutorialComplete.tsx
// module id = 1365
// module chunks = 3